import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faLinkedin,
  faGithub,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons";

function SocialLinks() {
  return (
    <div className="social-links">
      <a href="https://www.facebook.com/ragish.tandukar" target="_blank">
        <FontAwesomeIcon icon={faFacebook} />
      </a>
      <a target="_blank" href="https://github.com/Ragish">
        <FontAwesomeIcon icon={faGithub} />
      </a>
      <a target="_blank" href="https://twitter.com/Ragish77">
        <FontAwesomeIcon icon={faTwitter} />
      </a>
      <a
        target="_blank"
        href="https://www.linkedin.com/in/ragish-tandukar-871337a3/"
      >
        <FontAwesomeIcon icon={faLinkedin} />
      </a>
    </div>
  );
}

export default SocialLinks;
